/**
 * The 403 error codes `ApiClient`'s response interceptor reports on its own, kept in a leaf module
 * with no imports of its own.
 *
 * `trialSoftLock.ts` and `planEntitlement.ts` re-export their code from here and own the handling.
 * This module exists so `api-error-snackbar` can recognise those two 403s without pulling either
 * handler (and their `planNavigation` / store graph) into every chunk that reports an API error.
 */
export const TRIAL_SOFT_LOCKED_ERROR_CODE = 'trial-soft-locked'

export const PLAN_ENTITLEMENT_REQUIRED_ERROR_CODE = 'plan-entitlement-required'

const INTERCEPTOR_REPORTED_403_CODES: ReadonlySet<string> = new Set([
  TRIAL_SOFT_LOCKED_ERROR_CODE,
  PLAN_ENTITLEMENT_REQUIRED_ERROR_CODE
])

/**
 * True when the interceptor has already shown the user an upgrade nudge for this 403, so a call site
 * must stay quiet to avoid doubling up.
 *
 * Every *other* 403 is an ordinary authorization failure (access revoked, recipient removed from the
 * space, an endpoint the role cannot reach) that no interceptor reports — the call site is the only
 * thing that can tell the user, so it must not be lumped in with these two.
 */
export function isInterceptorReported403(error: unknown): boolean {
  const response = (error as { response?: { status?: unknown; data?: unknown } } | undefined)?.response
  if (response?.status !== 403) {
    return false
  }
  const code = (response.data as { code?: unknown } | undefined)?.code
  return typeof code === 'string' && INTERCEPTOR_REPORTED_403_CODES.has(code)
}
